// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 968 ? "ui-vendor" : chunkId) + "." + {"92":"efe362f7","215":"5b737015","393":"9e2ce412","508":"a5fe0a87","521":"9a7a29f4","813":"cfb52f27","968":"9193e468"}[chunkId] + ".chunk.js";
};